// ============================================================
// Farm/Land module — shared option lists & helpers
// (Kept here to avoid a Farms <-> FarmDetail circular import.)
// ============================================================

export const FARM_TYPES  = ['', 'Cropland', 'Ranch', 'Orchard', 'Vineyard', 'Mixed', 'Other'];
export const FARM_STATUS = ['Active', 'Fallow', 'Inactive'];

// Acreage / quantity formatter (format.js has no generic number formatter).
export const num = (v, dp = 2) => v != null && v !== '' ? Number(v).toLocaleString('en-US', { maximumFractionDigits: dp }) : '—';

// ------------------------------------------------------------
// Weather helpers (Open-Meteo data shown on the Farm "Weather" tab)
// ------------------------------------------------------------

// WMO weather interpretation codes -> { label, emoji }.
// https://open-meteo.com/en/docs (Weather variable documentation)
export const WMO_WEATHER = {
  0:  { label: 'Clear',                 emoji: '☀️' },
  1:  { label: 'Mainly Clear',          emoji: '🌤️' },
  2:  { label: 'Partly Cloudy',         emoji: '⛅' },
  3:  { label: 'Overcast',              emoji: '☁️' },
  45: { label: 'Fog',                   emoji: '🌫️' },
  48: { label: 'Rime Fog',              emoji: '🌫️' },
  51: { label: 'Light Drizzle',         emoji: '🌦️' },
  53: { label: 'Drizzle',               emoji: '🌦️' },
  55: { label: 'Heavy Drizzle',         emoji: '🌧️' },
  56: { label: 'Freezing Drizzle',      emoji: '🌧️' },
  57: { label: 'Freezing Drizzle',      emoji: '🌧️' },
  61: { label: 'Light Rain',            emoji: '🌦️' },
  63: { label: 'Rain',                  emoji: '🌧️' },
  65: { label: 'Heavy Rain',            emoji: '🌧️' },
  66: { label: 'Freezing Rain',         emoji: '🌧️' },
  67: { label: 'Freezing Rain',         emoji: '🌧️' },
  71: { label: 'Light Snow',            emoji: '🌨️' },
  73: { label: 'Snow',                  emoji: '🌨️' },
  75: { label: 'Heavy Snow',            emoji: '❄️' },
  77: { label: 'Snow Grains',           emoji: '🌨️' },
  80: { label: 'Light Showers',         emoji: '🌦️' },
  81: { label: 'Showers',               emoji: '🌧️' },
  82: { label: 'Violent Showers',       emoji: '⛈️' },
  85: { label: 'Snow Showers',          emoji: '🌨️' },
  86: { label: 'Snow Showers',          emoji: '🌨️' },
  95: { label: 'Thunderstorm',          emoji: '⛈️' },
  96: { label: 'Thunderstorm + Hail',   emoji: '⛈️' },
  99: { label: 'Thunderstorm + Hail',   emoji: '⛈️' },
};

export const weatherDesc = (code) =>
  code == null ? { label: '—', emoji: '' } : (WMO_WEATHER[code] || { label: 'Unknown', emoji: '🌡️' });

// Wind bearing (degrees) -> 16-point compass label.
const COMPASS = ['N','NNE','NE','ENE','E','ESE','SE','SSE','S','SSW','SW','WSW','W','WNW','NW','NNW'];
export const windCompass = (deg) =>
  deg == null || isNaN(deg) ? '' : COMPASS[Math.round((deg % 360) / 22.5) % 16];
